<template>
  <b-modal
    :id="'modal-tournament-win' + updatedTournamentWin.id"
    :hide-footer="true"
    modal-class="modal-tournament-win bg-img"
    @hidden="removeTournament()"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <a href="#" class="close-button" @click="close"> </a>
      <div
        id="header-logo"
        class="bg-img to-center-abs h-100"
        :class="$store.state.locale"
      ></div>
    </template>

    <template v-if="updatedTournamentWin" slot="default">
      <div
        class="w-100 d-flex flex-column align-items-center"
        style="margin-top: -50px"
      >
        <div class="slot-img-field" @click="handleSlotImgClick">
          <img
            draggable="false"
            :src="imgPath"
            class="w-100 h-100"
            @error="handleImageError"
          />
        </div>
        <span
          class="text-uppercase bold light-yellow-shadow"
          style="font-size: 26px"
        >
          {{ tourneyDateString }}
        </span>
        <span
          class="text-uppercase bold text-white red-shadow mt-3"
          style="font-size: 18px"
        >
          {{ $t("tournaments.info.reward") }}
        </span>
        <div class="d-inline-flex align-items-center justify-content-center">
          <span
            class="text-uppercase bold text-white red-shadow simple-line"
            style="font-size: 56px"
          >
            {{ goldWon }}</span
          >
          <BaseAsset asset="primary" size="big"></BaseAsset>
        </div>
        <div
          v-if="crownsWon"
          class="d-inline-flex align-items-center justify-content-center"
        >
          <span
            class="text-uppercase bold text-white red-shadow simple-line"
            style="font-size: 40px"
          >
            {{ crownsWon }}</span
          >
          <BaseAsset asset="secondary" size="big"></BaseAsset>
        </div>
        <span
          class="text-uppercase bold text-white red-shadow"
          :class="crownsWon ? '' : 'mt-3'"
          style="font-size: 16px"
        >
          {{ $t("tournaments.info.your_placement") }} </span
        ><span
          class="text-uppercase bold text-white red-shadow simple-line"
          style="font-size: 36px"
        >
          {{
            $t("tournaments.history.info.rank", {
              0: updatedTournamentWin.rank,
            })
          }}
        </span>
      </div>
    </template>
  </b-modal>
</template>

<script>
import BaseAsset from "../base/base-asset.vue";

export default {
  name: "ModalTournamentWin",
  components: { BaseAsset },

  props: { updatedTournamentWin: { type: Object, default: null } },

  computed: {
    gold: function () {
      if (this.updatedTournamentWin === null || !this.updatedTournamentWin) {
        return;
      }
      return this.formatNumber(this.updatedTournamentWin.gold_amount);
    },
    crowns: function () {
      if (this.updatedTournamentWin === null || !this.updatedTournamentWin) {
        return;
      }
      return this.updatedTournamentWin.crown_amount;
    },
    loyalty: function () {
      if (this.updatedTournamentWin === null || !this.updatedTournamentWin) {
        return;
      }
      return this.updatedTournamentWin.loyalty_amount;
    },

    dataGames: function () {
      return this.$store.getters["gameplay/getGames"];
    },
    imgPath() {
      return this.updatedTournamentWin.image_path;
    },
    tourneyDateString() {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };

      return (
        this.$t("tournaments.history.info.datetime2") +
        " " +
        new Date(this.updatedTournamentWin.end_date).toLocaleDateString(
          this.$store.state.locale,
          options
        )
      );
    },
    goldWon() {
      return this.formatNumber(this.updatedTournamentWin.gold_amount);
    },
    crownsWon() {
      if (!this.updatedTournamentWin.crown_amount) return null;
      return this.formatNumber(this.updatedTournamentWin.crown_amount);
    },
  },
  watch: {
    updatedTournament: {
      handler(data) {
        if (!data) {
          return;
        }
        this.data = data;
        this.$store.commit("tournaments/setTournamentUpdateWin", null);
      },
    },
  },

  mounted: function () {
    this.$bvModal.show("modal-tournament-win" + this.updatedTournamentWin.id);
  },

  methods: {
    handleImageError(event) {
      event.target.src = this.$whitelabel.assets.logos.slotPlaceholder;
    },
    removeTournament: function () {
      this.$store.commit(
        "tournaments/removeTournamentUpdateWin",
        this.updatedTournamentWin.id
      );
    },
    handleSlotImgClick() {
      this.$bvModal.hide("modal-tournament-win" + this.updatedTournamentWin.id);
      this.$router.push("/tournament/history");
    },
  },
};
</script>
<style lang="scss">
$modal-width: 640px;
$modal-height: 800px;

.modal-tournament-win {
  .modal-dialog {
    max-width: $modal-width;
    height: $modal-height !important;
    background: url(~@/assets/img/tournament/tourney-overlay-win-bg.png)
      center/100% 100% no-repeat;
    .modal-content {
      background-color: transparent;
      border: none;
      .modal-header {
        border: none;
        height: 291px;
        position: relative;
        .close-button {
          right: 0;
          top: 50px;
        }
        #header-logo {
          width: 497px;
          &.de {
            background-image: url(~@/assets/img/tournament/tourney-overlay-head-de.png);
          }
          &.en {
            background-image: url(~@/assets/img/tournament/tourney-overlay-head-eng.png);
          }
        }
      }
      .slot-img-field {
        width: 160px;
        height: 103px;
        &:hover {
          cursor: pointer;
          box-shadow: 0 0 26px #4f0a00, 0 0 20px #4f0a00,
            0 0 16px $text-red-line, 0 0 11px $text-red-line,
            0 0 11px $text-red-line, 0 0 5px $text-red-line,
            0 0 5px $text-red-line, 0 0 5px $text-red-line;
        }
      }
      .light-yellow-shadow {
        color: $text-light-gold;
        text-shadow: 0 1px 4px black;
      }
      .red-shadow {
        text-shadow: 0 0 26px #4f0a00, 0 0 13px #4f0a00, 0 0 13px $text-red-line,
          0 0 6px $text-red-line;
      }

      .simple-line {
        line-height: 1.1;
      }
    }

    @media (max-height: 750px), (max-width: 1200px) {
      transform: scale(0.8) !important;
      top: -80px !important;
      margin-bottom: -20%;
    }
  }
}
</style>
